export default __webpack_public_path__ + "static/media/full-slider-dot.3f00d9ab.svg";